import { SET_DSR_TEMPLATE_MAIN_CONTACT } from "../../actions/dsr-template-actions-types";


const INITIAL_STATE_DSR_MAIN_CONTACT = { results: "" }

export function setDsrTemplateMainContactReducer(state = INITIAL_STATE_DSR_MAIN_CONTACT, action) {
    switch (action.type) {
        case SET_DSR_TEMPLATE_MAIN_CONTACT:
            return { results: action.payload }
        default:
            return state;
    }
}